import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterFlujoCajaResumido from 'views/reports/flujoCajaResumido/filterFlujoCajaResumido'; // Importing filter component
import TableFlujoCajaResumido from 'views/reports/flujoCajaResumido/tableFlujoCajaResumido'; // Importing table component
import DetailsFlujoCajaResumido from 'views/reports/flujoCajaResumido/detailsFlujoCajaResumido'; // Importing details component
import RecordFlujoCajaResumido from 'views/reports/flujoCajaResumido/recordFlujoCajaResumido'; // Importing record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * SummaryCashFlowView class extends JetView to create a summary cash flow view.
 */
export default class SummaryCashFlowView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration

        const right = {
            // Right section of the layout
            type: 'wide',
            rows: [
                PlayersView, // Players view component
                DetailsFlujoCajaResumido, // Details view component
                RecordFlujoCajaResumido, // Record view component
            ],
        };

        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            id: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 1000000, // Maximum number of items to display
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            if (value == 1) {
                                // Excel export
                                var table = $$('CashResume'); // Reference to the cash resume table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    docHeader: {
                                        text:
                                            _('Descripción del reporte: Flujo Caja Resumido ') +
                                            '\n' +
                                            _('Fecha de reporte: Desde ') +
                                            $$('Datepicker').getValue().substr(0, 10) +
                                            _(' Hasta ') +
                                            $$('Datepicker').getValue().substr(12, 20) +
                                            '\n' +
                                            _(' Fecha creación del reporte: ') +
                                            webix.Date.add(new Date(), -0, 'day').getFullYear() +
                                            '-' +
                                            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
                                            '-' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getHours()).slice(-2) +
                                            ':' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getMinutes()).slice(-2),
                                        textAlign: 'right',
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('CashResume').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Flujo Caja Resumido'),
                                    ignore: { detailTittle: true }, // Ignore detail title in export
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('CashResume'), {
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('CashResume').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Flujo Caja Resumido'),
                                        autowidth: true, // Automatically adjust width
                                        ignore: { detailTittle: true }, // Ignore detail title in export
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        const left = {
            // Left section of the layout
            css: 'int-left',
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme, // Apply theme CSS
                    elements: [
                        { view: 'label', label: _('Flujo de Caja Resumido') }, // Title label
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            id: 'button-search', // Search button
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-search', // Search icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => {
                                        $$('filterPopup').show(); // Show filter popup on click
                                    },
                                },
                            ],
                        },
                        {
                            type: 'wide',
                            css: 'close-bottom',
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    bottom: 20,
                                    right: 35,
                                    width: 30,
                                    height: 30,
                                    click: () => this.show('/top/dashboard'), // Navigate to dashboard on click
                                },
                            ],
                        },
                    ],
                },
                FilterFlujoCajaResumido, // Filter component
                TableFlujoCajaResumido, // Table component
                toolbar, // Toolbar component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [left], // Left section
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500 || screen.height < 500) {
                $$('toolbar').hide(); // Hide toolbar on small screens
            }
            if (screen.width > 500 && screen.height > 500) {
                $$('button-search').hide(); // Hide search button on larger screens
            }
        });
    }
}

// FILE DOCUMENTED
